// extracted by mini-css-extract-plugin
export default {"text":"AddAppointmentFab_text__nhfKL"};